import { render, staticRenderFns } from "./spinner.vue?vue&type=template&id=06decd14&"
var script = {}
import style0 from "./spinner.vue?vue&type=style&index=0&lang=less&"
import style1 from "spinkit/scss/spinkit.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports